/**
 * Add a roadmap ("Ideas") comment (or reply).
 *
 * Mirrors Flutter RoadmapRepository.addComment
 *   (lib/data/repository/roadmap_repository.dart:60-65): passes the notification
 *   through only when `sendCommentNotification`, and forwards the reply
 *   popularity to the data layer.
 *
 * Unlike the content AddCommentUseCase sibling, the roadmap comment widget does
 * NOT run a mention fan-out (no processCommentMentions), so none is added here.
 */

import { RoadmapCommentService } from '@/domain/services/roadmapComment/roadmapCommentService';
import { COMMENTS_CONSTANTS } from '@/domain/constants/commentsConstants';
import type { RoadmapCommentEntity } from '@/domain/entities/roadmapComment/roadmapCommentEntity';
import type { NotificationInfoDto } from '@/data/dtos/info/notificationInfoDto';

export interface AddRoadmapCommentParams {
  comment: RoadmapCommentEntity;
  sendCommentNotification: boolean;
  notification: NotificationInfoDto | null;
  currentUserPopularityForReply?: number;
}

export class AddRoadmapCommentUseCase {
  constructor(private service = RoadmapCommentService.getInstance()) {}

  async execute(params: AddRoadmapCommentParams): Promise<boolean> {
    const replyPopularity =
      params.currentUserPopularityForReply ??
      COMMENTS_CONSTANTS.DEFAULT_REPLY_POPULARITY_FOR_COMMENT;

    return this.service.addComment(
      params.comment,
      params.sendCommentNotification ? params.notification : null,
      replyPopularity,
    );
  }
}

export const addRoadmapCommentUseCase = new AddRoadmapCommentUseCase();
